import { withAPIAccount } from '../../lib/http/api';
import { APIError, parsedResponse } from '../../lib/http/http';
import { AccountType, IAPIAppConfig } from '../../model';
import { ADMIN_PREFIX, APP_CONFIG_PREFIX } from '../config';
import {
  IAPIAddAppConfigParams,
  IAPIAppConfigItem,
  IAPIPutAppConfigParams,
} from '../../model/api-modules/app-config';
import { messageError } from '../../components/message';

export const getAppConfigApi = (hostname: string) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${APP_CONFIG_PREFIX}/${hostname}`;
      const response = await api.commonRequest('GET', url);
      return await parsedResponse<IAPIAppConfig>(response, 'data');
    } catch (error) {
      if (error instanceof APIError) {
        messageError(error.apiError?.message);
      }
      return null;
    }
  });

export const getAdminAppConfig = () =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_PREFIX}/app-config`;
      const response = await api.commonRequest('GET', url);
      const res = await parsedResponse<ReadonlyArray<IAPIAppConfigItem>>(
        response,
        'data'
      );
      return res;
    } catch (error) {
      return [];
    }
  });

// 修改
export const putAdminAppConfig = (id: number, params: IAPIPutAppConfigParams) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_PREFIX}/app-config/${id}`;
      const response = await api.commonRequest('PUT', url, params);
      const res = await parsedResponse<number>(response, 'code');
      return res;
    } catch (error) {
      return -1;
    }
  });

// 新增
export const addAdminAppConfig = (params: IAPIAddAppConfigParams) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_PREFIX}/app-config`;
      const response = await api.commonRequest('POST', url, params);
      const res = await parsedResponse<number>(response, 'code');
      return res;
    } catch (error) {
      return -1;
    }
  });

// 删除
export const delAdminAppConfig = (id: number) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_PREFIX}/app-config/${id}`;
      const response = await api.commonRequest('DELETE', url);
      const res = await parsedResponse<number>(response, 'code');
      return res;
    } catch (error) {
      return -1;
    }
  });
